var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H26C28.2091 0 30 1.79086 30 4V26C30 28.2091 28.2091 30 26 30H4C1.79086 30 0 28.2091 0 26V4Z",
    fill: "#243857"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40593 20.2189C9.65593 18.9689 9.78093 18.6564 10.5622 19.4377C11.3434 20.2189 11.0309 20.3126 9.78093 21.5939C8.84343 22.5314 7.65593 22.3439 7.65593 22.3439C7.65593 22.3439 7.46843 21.1564 8.40593 20.2189Z",
    fill: "#FF9D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7809 21.5002C11.2809 20.1877 11.4372 20.0314 10.7184 19.6252C9.99968 19.2189 9.99968 19.5002 9.53093 20.8127C9.15593 21.7814 9.59343 22.6564 9.59343 22.6564C9.59343 22.6564 10.4372 22.5002 10.7809 21.5002Z",
    fill: "#FF9D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0623 20.2809C10.3435 19.5622 10.3435 19.4059 10.7185 19.6247C11.1248 19.8434 11.031 19.9372 10.7498 20.6559C10.5623 21.1872 10.0935 21.3122 10.0935 21.3122C10.0935 21.3122 9.87477 20.8434 10.0623 20.2809Z",
    fill: "#FDF516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3438 19.2809C9.9375 18.5622 9.78125 18.7184 8.46875 19.2184C7.5 19.5934 7.3125 20.4059 7.3125 20.4059C7.3125 20.4059 8.1875 20.8434 9.15625 20.4684C10.4688 19.9684 10.75 19.9684 10.3438 19.2809Z",
    fill: "#FF9D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 19.9371C10.4062 19.6558 10.5625 19.6558 10.3438 19.2808C10.125 18.8746 10.0313 18.9683 9.3125 19.2496C8.78125 19.4371 8.65625 19.9058 8.65625 19.9058C8.65625 19.9058 9.15625 20.1246 9.6875 19.9371Z",
    fill: "#FDF516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3443 19.875C10.0318 19.1875 10.0943 19 10.5318 19.4375C10.9693 19.875 10.7818 19.9375 10.0943 20.625C9.56305 21.1562 8.9068 21.0312 8.9068 21.0312C8.9068 21.0312 8.8443 20.4062 9.3443 19.875Z",
    fill: "#FDF516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 16.8746C8.84375 13.6246 5.625 14.9683 5.625 14.9683C5.625 14.9683 10.2188 10.3746 13.3125 13.4683L10.7812 16.8746Z",
    fill: "#3BAACF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2812 14.4683L13.2812 13.4683C10.2188 10.3746 5.625 14.9683 5.625 14.9683C5.625 14.9683 9.65625 12.0933 12.2812 14.4683Z",
    fill: "#428BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 19.2187C16.375 21.1562 15.0312 24.375 15.0312 24.375C15.0312 24.375 19.625 19.7812 16.5313 16.6875L13.125 19.2187Z",
    fill: "#3BAACF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5313 17.7188L16.5313 16.7188C19.625 19.8125 15.0312 24.4062 15.0312 24.4062C15.0312 24.4062 17.9063 20.3437 15.5313 17.7188Z",
    fill: "#428BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2493 14.6565C16.5931 18.2815 12.5619 20.2503 11.1556 18.844C9.74935 17.4378 11.7181 13.4065 15.3431 9.75026C19.5931 5.50026 24.3118 5.68776 24.3118 5.68776C24.3118 5.68776 24.4681 10.4065 20.2493 14.6565Z",
    fill: "#C5D0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3132 13.625C15.6882 17.25 12.0632 19.625 11.2194 18.7812C10.3757 17.9375 12.7507 14.3125 16.3757 10.6875C20.6257 6.4375 24.3757 5.625 24.3757 5.625C24.3757 5.625 23.5632 9.375 19.3132 13.625Z",
    fill: "#DAE3EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5937 19.8438C12.4375 20 12.1875 20 12.0312 19.8438L10.1562 17.9688C10 17.8125 10 17.5312 10.1562 17.375L10.7187 16.8125L13.1562 19.25L12.5937 19.8438Z",
    fill: "#C94747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0616 19.2813C11.9054 19.4375 11.7179 19.5 11.6241 19.4062L10.5616 18.3438C10.4679 18.25 10.5304 18.0625 10.6866 17.9062L11.2491 17.3438L12.6241 18.7188L12.0616 19.2813Z",
    fill: "#F15744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5312 20.0625C11.4375 20.1562 11.2187 20.1562 11.125 20.0625L9.90625 18.8437C9.8125 18.75 9.84375 18.5625 9.9375 18.4687L10.3125 18.0938L11.9062 19.6875L11.5312 20.0625Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2813 19.8125C11.1875 19.9063 11 19.9375 10.9375 19.875L10.0937 19.0313C10.0312 18.9688 10.0625 18.8125 10.1875 18.7188L10.5625 18.3438L11.6562 19.4375L11.2813 19.8125Z",
    fill: "#62727A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3125 5.6875C24.3125 5.6875 22.625 5.625 20.3438 6.5L23.5 9.65625C24.375 7.375 24.3125 5.6875 24.3125 5.6875Z",
    fill: "#C94747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3125 5.6875C24.3125 5.6875 22.9687 5.96875 20.9375 7.125L22.875 9.0625C24.0312 7.03125 24.3125 5.6875 24.3125 5.6875Z",
    fill: "#F15744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5938 12.9688C19.4567 12.9688 20.1562 12.2692 20.1562 11.4062C20.1562 10.5433 19.4567 9.84375 18.5938 9.84375C17.7308 9.84375 17.0312 10.5433 17.0312 11.4062C17.0312 12.2692 17.7308 12.9688 18.5938 12.9688Z",
    fill: "#EDF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5937 12.4375C19.1633 12.4375 19.625 11.9758 19.625 11.4062C19.625 10.8367 19.1633 10.375 18.5937 10.375C18.0242 10.375 17.5625 10.8367 17.5625 11.4062C17.5625 11.9758 18.0242 12.4375 18.5937 12.4375Z",
    fill: "#3BAACF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 16.0938C16.3317 16.0938 17.0312 15.3942 17.0312 14.5312C17.0312 13.6683 16.3317 12.9688 15.4688 12.9688C14.6058 12.9688 13.9062 13.6683 13.9062 14.5312C13.9062 15.3942 14.6058 16.0938 15.4688 16.0938Z",
    fill: "#EDF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4687 15.5625C16.0383 15.5625 16.5 15.1008 16.5 14.5312C16.5 13.9617 16.0383 13.5 15.4687 13.5C14.8992 13.5 14.4375 13.9617 14.4375 14.5312C14.4375 15.1008 14.8992 15.5625 15.4687 15.5625Z",
    fill: "#3BAACF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2813 7.15625C20.1875 7.25 20 7.25 19.9062 7.15625C19.8125 7.0625 19.8125 6.875 19.9062 6.78125C20 6.6875 20.1875 6.6875 20.2813 6.78125C20.375 6.875 20.375 7.0625 20.2813 7.15625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 7.9375C20.9506 7.9375 21.0625 7.82557 21.0625 7.6875C21.0625 7.54943 20.9506 7.4375 20.8125 7.4375C20.6744 7.4375 20.5625 7.54943 20.5625 7.6875C20.5625 7.82557 20.6744 7.9375 20.8125 7.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 8.6875C21.7006 8.6875 21.8125 8.57557 21.8125 8.4375C21.8125 8.29943 21.7006 8.1875 21.5625 8.1875C21.4244 8.1875 21.3125 8.29943 21.3125 8.4375C21.3125 8.57557 21.4244 8.6875 21.5625 8.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2812 9.4375C22.4193 9.4375 22.5312 9.32557 22.5312 9.1875C22.5312 9.04943 22.4193 8.9375 22.2812 8.9375C22.1432 8.9375 22.0312 9.04943 22.0312 9.1875C22.0312 9.32557 22.1432 9.4375 22.2812 9.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0312 10.1563C23.1693 10.1563 23.2812 10.0443 23.2812 9.90625C23.2812 9.76818 23.1693 9.65625 23.0312 9.65625C22.8932 9.65625 22.7812 9.76818 22.7812 9.90625C22.7812 10.0443 22.8932 10.1563 23.0312 10.1563Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon1);
export default __webpack_public_path__ + "static/media/ProjectIcon1.9555b7cc34e797d229d19551a88854c9.svg";
export { ForwardRef as ReactComponent };